import React from 'react';
import { getStatusLabel, STATUS_BADGE_COLORS } from '../constants';
import { StatusBadgeWrapper } from './style';

interface StatusBadgeProps {
  status: number | null;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  if (status === null || status === undefined) {
    return <span>—</span>;
  }

  const colors = STATUS_BADGE_COLORS[status] ?? {
    bg: '#F0F0F0',
    color: '#666666',
  };

  return (
    <StatusBadgeWrapper $bg={colors.bg} $color={colors.color}>
      {getStatusLabel(status)}
    </StatusBadgeWrapper>
  );
};

export default StatusBadge;
